<template>
  <div>
    <b-container class="results">
      <b-row>
        <b-col class="mb-4" cols="12" v-for="resource in searchResult" :key="resource.filePath">
          <resource :resource="resource"></resource>
        </b-col>

        <b-col v-if="searchResult.length <= 0" id="no-search-results" class="fadeIn animated">
          <h3>Kein Ergebnis gefunden!</h3>
          <p>Es tut uns sehr leid, aber leider konnten keine Zusatzmaterialien unter diesem Link gefunden werden.</p>

          <p>Bitte prüfen Sie den Link, falls dieser korrekt sein sollte, kontaktieren Sie uns bitte.</p>
        </b-col>
      </b-row>

      <div style="text-align: center; padding-top: 30px; padding-bottom: 30px">
        <b-button to="/resources/list">Alle Materialien ansehen</b-button>
      </div>
    </b-container>
  </div>
</template>

<script>
  import Resource from './Resource'
  import ResourceTypeFilter from './ResourceTypeFilter'
  import ResourceLangFilter from './ResourceLangFilter'

  const Loki = require('lokijs')

  export default {
    name: 'ResourceSearchKasaBook21',
    data () {
      return {
        searchInput: ''
      }
    },
    components: {
      Resource,
      ResourceTypeFilter,
      ResourceLangFilter
    },
    mounted () {
      this.$http.get('/static/resourceDB.json').then(function (response) {
        this.db = new Loki('resources')
        this.db.loadJSONObject(response.body)
        this.resourceCollection = this.db.getCollection('resources')

        if (this.$route.params.searchString) {
          this.searchInput = this.$route.params.searchString
        }
      })
    },
    computed: {
      searchResult: function () {
        if (this.searchInput === '') {
          return []
        }

        return this.resourceCollection.chain().where((obj) => {
          if (obj['kasa_book_21_ref'] !== undefined && obj['kasa_book_21_ref'] === this.searchInput) {
            return true
          }

          return false
        }).simplesort('page').data()
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import '../style/bootstrap-component-include';
  @import '~animate.css/animate.css';

  .container {
    margin-top: 15px;
  }

  #no-search-results, #too-short-search {
    animation-delay: .5s;
  }

  .results {
    min-height: 50vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResourceKasaBook21.vue